import React, { Component } from 'react';
import {Tile, TileContainer} from "./TileView";
import {Container} from "reactstrap";
import Product from "./Product";
import CustomToggle from "./CustomToggle";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

export class Home extends Component {
  static displayName = Home.name;
  
  constructor(props)
  {
      super(props)
      
      this.state = {chapt:0, products:[], filteredProducts:[], loading:true, error:null }
  }

  async componentDidMount() {
      try {
          let resp = await fetch("product")
          if (!resp.ok) throw new Error('Ошибка загрузки товаров')
          let json = await resp.json()
          this.setState({products:json, filteredProducts: this.recomendedFilter(json), loading:false})
      } catch (e) {
          this.setState({loading:false, error: e.message})
      }
  }

  getNew()
  {
      this.setState({filteredProducts: this.state.products.filter(it => it.new)})
  }
  getHot()
  {
      this.setState({filteredProducts: this.state.products.filter(it => it.hot)})
  }

  recomendedFilter(prods)
  {
      return prods.filter(it => it.type == "Коляски").sort((a,b) => {return (a.calculatedPrice - a.price) -  (b.calculatedPrice - b.price)})
  }

  getRec()
  {
      this.setState({filteredProducts:this.recomendedFilter(this.state.products)})
  }
  updateChapter(chaptNum)
  {
      this.setState({chapt:chaptNum})
      switch (chaptNum)
      {
          case 0:
              this.getRec();
              break;
          case 1:
              this.getNew();
              break;
          case 2:
              this.getHot();
              break;
      }

  }
  
  render() {
      
    return (
        <>
        <Helmet>
            <title>iCandy — премиальные детские коляски</title>
            <meta name="description" content="Детские коляски премиум класса iCandy — британское качество, инновационный дизайн. Peach, Lime, Orange, Cerium, Land Rover." />
            <meta property="og:title" content="iCandy — премиальные детские коляски" />
            <meta property="og:description" content="Детские коляски премиум класса iCandy — британское качество и инновационный дизайн." />
        </Helmet>
        <div className="hero">
            <div className="hero-bg" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/icandy-lifestyle-1.webp)`}} />
            <div className="hero-overlay" />
            <div className="hero-content">
                <h1 className="hero-title">Премиальные детские коляски iCandy</h1>
                <p className="hero-subtitle">Британское качество и безупречный дизайн для вашего малыша</p>
                <Link to="/catalog" className="hero-cta">Смотреть каталог</Link>
            </div>
        </div>
        <TileContainer>
            <Tile text="Peach" image="peach7-plush_fabric_desk.webp" page="/catalog?collection=Peach"/>
            <Tile text="Cerium" image="safe-sleeping-3560.webp" page="catalog?collection=Peach Designer Collection Cerium"/>
            <Tile text="Lime" image="lime-prew.webp" page="/catalog?collection=Lime"/>
            <Tile text="ICandy for Land Rover" image="icandt for land.jpg" page="/catalog?collection=ICandy for Land Rover"/>
            <Tile text="Orange" image="orange-comfort-d.webp" page="/catalog?collection=Orange"/>
        </TileContainer>
      <Container>
          <div className="d-flex justify-content-center flex-wrap gap-3 m-3">
              <CustomToggle text = "Рекомендуем" selected={this.state.chapt === 0} onClick={()=> this.updateChapter(0)} />
              <CustomToggle text = "Новинки" selected={this.state.chapt === 1} onClick={()=> this.updateChapter(1)} />
              <CustomToggle text = "Хиты продаж" selected={this.state.chapt === 2} onClick={()=> this.updateChapter(2)} />
          </div>
          {this.state.error && <p className="text-center text-muted mt-4">{this.state.error}</p>}
          {this.state.loading
            ? <div className="product-grid">{Array.from({length:8}).map((_,i) => <div key={i} className="skeleton" />)}</div>
            : <div className="product-grid">
              {this.state.filteredProducts.map((val) => {
                  return (<Product key = {val.id} product={val}/>)
              })}
          </div>}
      </Container>
        </>
    );
  }
}
